import { ActionTypes, IAction, IPageState } from './types';

export const InitialState: IPageState = {
  loading: false,
  zeroState: false,
  allLiveTransactions: {
    page: 0,
    pageSize: 20,
    content: [],
    totalElements: 0,
  },
};

export const Reducer = (state: IPageState, action: IAction): IPageState => {
  switch (action.type) {
    case ActionTypes.UPDATE_LOADING_STATUS:
      return {
        ...state,
        loading: action.payload?.status ?? false,
      };
    case ActionTypes.GET_ALL_LIVE_TRANSACTIONS:
      return {
        ...state,
        loading: false,
        allLiveTransactions: action.payload?.allLiveTransactions ?? { ...InitialState.allLiveTransactions },
      };
    case ActionTypes.SHOW_ZERO_STATE:
      return {
        ...state,
        loading: false,
        zeroState: action.payload?.zeroState ?? false,
      };
    default:
      return { ...state };
  }
};
